'use strict';

import React, { Component } from 'react';
import zChat from 'vendor/web-sdk';
import { log } from 'utils';
class LoadingScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
          // connection : 'closed'
          isLoading : false
        }
        this.newConversation = this.newConversation.bind(this);

      }

      newConversation(){
        let convo_button  = document.getElementById('new-conversation-button');
        convo_button.disabled = true
        this.setState({
          isLoading : true
        })
        document.cookie = '__zlcmid' + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';




        this.props.isNewChatIncrement();
        zChat.reconnect();

        this.props.dispatch({
          type : 'ON_EXIT',
          detail : {}
        });
        this.props.isNewChatIncrement();

        setTimeout(()=> {
          let visitorInfo = {
            display_name : ''
        };
          zChat.setVisitorInfo(visitorInfo,(err)=>{

            if(err) {log(err)}
            // console.log("++++NEW BUTTON ChaT+++++++++++++")
            zChat.sendChatMsg('default_welcome', (err) => {
              if (err) {
                // console.log('Error occured >>>', err);
              }
              this.setState({
                isLoading : false
              });
              convo_button.disabled = false
            });
           });
        } , 2000);


        // this.setState({
        //   connection : 'connected'
        // })
      //   setTimeout(()=>{ this.setState({
      //     isLoading : false
      //   });
      //   convo_button.disabled = false;
      // }, 2000)

      }

      render(){
          // const connection = 'closed';
          return (
            <div className={`spinner-container ${this.props.visible && this.props.connection !== 'connected' ? 'visible' : ''}`}>
                <div className="spinner"
                 style ={this.props.connection ==  'connecting' ? {} : {display : 'none'}}
                 ></div>

                {this.props.connection == 'closed' &&
                 <div className="new-conversation-div">
                        <button className="new-conversation-btn" onClick={this.newConversation}  id='new-conversation-button'>
                            neues Gespräch
                        </button>
                        {(this.props.connection == 'closed' && this.state.isLoading) && <div className='loading-container'>
                          <div className='loader-css'></div>
                        </div>}
                </div>}
            </div>
          )
      }
 
}

export default LoadingScreen;



// WEBPACK FOOTER //
// ./src/components/LoadingScreen.js